
export const maxLength = max => value =>
    value && value.length > max ? 'error_title_too_long' : undefined
export const required = value => value ? undefined : 'error_required'
